export default __webpack_public_path__ + "static/media/highlights.9c20e44d.png";